import React, { Component } from 'react';
export default class ComparisonKey extends Component {
  render() {
    const keyTypes = [
        'Current Reviewers',
        'Previous Reviewers',
        'Current Self',
        'Previous Self'
    ]
    return (
      <div className={`w-100 row flex mb2 ${this.props.spacing ? 'mt4 pt3' : ''}`}>
        <div className='w-100 pt1 pb0 flex justify-between'>
          {keyTypes.map((keyTitle, i) => {
            return (
            <div key={keyTitle} className='flex'>
              <span
                className={`h-100 db mr1 ba`}
                style={{
                  height: '15px',
                  width: '15px',
                  backgroundColor: i > 1 ? `#0051ff` : '#F563B9',
                  opacity: i % 2 === 0 ? '' : '0.4'
                }}
              ></span>
              <strong>{keyTitle} Rating</strong>
            </div>
            )
          })}
        </div>
      </div>
    );
  }
}